/* eslint-disable no-magic-numbers */
import { useCallback } from 'react';
import { useQuery } from '../useQuery';

export function usePagination() {
  const [query, setQuery] = useQuery();

  const handleChangePage = useCallback(
    (page, count) => {
      setQuery({ ...query, page, count });
    },
    [query]
  );

  const handleChangeCount = useCallback(
    (page, count) => {
      setQuery({ ...query, page, count });
    },
    [query]
  );

  return {
    page: +query.page || 1,
    count: +query.count || 20,
    handleChangePage,
    handleChangeCount,
  };
}
